import { utils } from '@makeship/core';
import React from 'react';
import styled from 'styled-components';

type TextCalloutProps = {
  children: React.ReactNode;
  isDiscount?: boolean;
};

const TextCalloutContainer = styled.div<{
  isDiscount?: boolean;
}>`
  padding: 10px;
  border-radius: 8px;
  background: ${({ theme, isDiscount }) =>
    isDiscount
      ? 'linear-gradient(95deg, #fff 0.12%, #ffe7ab 100.12%)'
      : utils.hexToRGBA(theme.colors.neutral1, theme.alpha.light)};
  border: 1px solid
    ${({ theme, isDiscount }) =>
      isDiscount
        ? utils.hexToRGBA(theme.colors.neutral7, theme.alpha.medium)
        : utils.hexToRGBA(theme.colors.neutral7, theme.alpha.light)};
`;

const TextCallout: React.FC<TextCalloutProps> = ({ children, isDiscount }: TextCalloutProps) => (
  <TextCalloutContainer isDiscount={isDiscount}>{children}</TextCalloutContainer>
);

export default TextCallout;
